// extracted by mini-css-extract-plugin
export default {"container":"EmailConfirmation_container__L2rn1"};